"use client";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { SlSettings } from "react-icons/sl";
import { Settings } from "./settings";

const preventHover = (event: any) => {
  const e = event as Event;
  e.preventDefault();
};

export function SettingsMenu() {
  return (
    <NavigationMenu tabIndex={-1} className="mr-1">
      <NavigationMenuList tabIndex={-1} className="">
        <NavigationMenuItem tabIndex={-1} className="">
          <NavigationMenuTrigger
            tabIndex={-1}
            type="button"
            onPointerMove={preventHover}
            onPointerLeave={preventHover}
          >
            <SlSettings />
          </NavigationMenuTrigger>
          <NavigationMenuContent
            tabIndex={-1}
            className=""
            onPointerLeave={preventHover}
            onPointerEnter={preventHover}
          >
            <Settings />
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
